export default __webpack_public_path__ + "static/media/Askeladden2.e10e54fd.jpg";